"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedInterleavedLine2dHitTestComponent = void 0;
const rc_js_util_1 = require("rc-js-util");
const indexable_point_entity_line_hit_tester_1 = require("../../hit-test/indexable-point-entity-line-hit-tester");
const shared_interleaved_line_2d_quad_indexer_factory_1 = require("./shared-interleaved-line-2d-quad-indexer-factory");
/**
 * @public
 * Where an entity makes use of shared buffers it can be indexed natively, potentially providing a significant performance boost.
 * Otherwise equivalent to {@link InterleavedLine2dHitTestComponent}.
 */
class SharedInterleavedLine2dHitTestComponent {
    constructor(indexer) {
        this.indexer = indexer;
        this.sharedObject = new rc_js_util_1.LinkedReferenceCounter([indexer.sharedObject]);
    }
    static createOne(emscriptenModule, ctor) {
        const indexer = shared_interleaved_line_2d_quad_indexer_factory_1.SharedInterleavedLine2dQuadIndexerFactory.createOne(emscriptenModule, ctor);
        const hitTestComponent = new SharedInterleavedLine2dHitTestComponent(indexer);
        indexer.sharedObject.release();
        return hitTestComponent;
    }
    hitTest(entity, indexOfFirstPoint, cssPosition, updateArg) {
        return indexable_point_entity_line_hit_tester_1.IndexablePointEntityLineHitTester.hitTestEntity(entity, indexOfFirstPoint, cssPosition, updateArg);
    }
    index(entity, updateArg, tree) {
        this.indexer.addToTree(tree, entity, updateArg.interactionTransforms.dataToInteractiveArea, updateArg.userTransform);
    }
}
exports.SharedInterleavedLine2dHitTestComponent = SharedInterleavedLine2dHitTestComponent;
//# sourceMappingURL=shared-interleaved-line2d-hit-test-component.js.map